module.exports = __webpack_public_path__ + "img/19ne.e3847207.svg";